import { setSelectedEnrollment } from '@actions/memberPortal/enrollmentsActionCreators';
import { TXN_REASON, TXN_TYPES } from '@constants/enrollmentList/enrollmentList.constant';
import { formatDateToMMDDYYYY } from '@utils/dates/dateMethods';
import { getUISsnFormat } from '@utils/normalize/normalizeSsn';
import useAppDispatch from './useAppDispatch';

const useSetSelectedEnrollment = () => {
    const dispatch = useAppDispatch();

    return enrollment => {
        const enrollmentBenefitEffectiveEndDateUI = formatDateToMMDDYYYY(enrollment.enrollmentBenefitEffectiveEndDate);
        const enrollmentBenefitEffectiveStartDateUI = formatDateToMMDDYYYY(
            enrollment.enrollmentBenefitEffectiveStartDate,
        );

        const startDate = new Date(enrollment.enrollmentBenefitEffectiveStartDate).getMonth() + 1;
        const endDate = new Date(enrollment.enrollmentBenefitEffectiveEndDate).getMonth() + 1;

        const enrollmentPremiumDtoList = enrollment?.enrollmentPremiumDtoList?.sort((a, b) => a.month - b.month);
        const enrolleeDataDtoList = enrollment?.enrolleeDataDtoList?.map((enrollee, index) => ({
            ...enrollee,
            enrolleeEffectiveStartDateUI: formatDateToMMDDYYYY(enrollee?.enrolleeEffectiveStartDate),
            enrolleeEffectiveEndDateUI: formatDateToMMDDYYYY(enrollee?.enrolleeEffectiveEndDate),
            taxIdentificationNumber: getUISsnFormat(enrollee.taxIdentificationNumber),
            txnType: TXN_TYPES.Change,
            txnReason: TXN_REASON.TwentyNine,
            index: index,
        }));

        dispatch(
            setSelectedEnrollment({
                ...enrollment,
                enrolleeDataDtoList,
                enrollmentBenefitEffectiveEndDateUI,
                enrollmentBenefitEffectiveStartDateUI,
                enrollmentPremiumDtoList,
                originalEnrollmentBenefitEffectiveEndMonth: startDate,
                enrollmentBenefitEffectiveStartMonth: startDate,
                enrollmentBenefitEffectiveEndMonth: endDate,
                originalEnrollmentBenefitEffectiveStartMonth: endDate,
            }),
        );
    };
};

export default useSetSelectedEnrollment;
